// extracted by mini-css-extract-plugin
export default {"component":"externalEmployeeForm__component___N8BDv","textField":"externalEmployeeForm__textField___pMECB"};